import { defineComponent as _defineComponent } from 'vue'
import { ModuleName } from '@/types/module-type';
import WphkBanner, { BannerConfig } from '@tencent/wphk-components-banner';
import { onBeforeMount, ref } from 'vue';
import { useConfigStore } from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'banner',
  props: {
    moduleName: null
  },
  setup(__props: any) {

const props = __props as { moduleName: ModuleName }


const { getConfig } = useConfigStore();
// banner 列表
const bannerList = ref<BannerConfig[]>();
onBeforeMount(async () => {
  const { bannerList: bannerListVal = [] } = await getConfig(props.moduleName);
  bannerList.value = bannerListVal;
});

return { __sfc: true,props, getConfig, bannerList, WphkBanner }
}

})